import { Event } from '../../../types/event'
import { formatDate } from '../../../utils/numbersFormatting'

interface EventItemProps {
  event: Event
}

export default function EventItem({ event }: EventItemProps) {
  return (
    <div className="[&:not(:last-child)]:pb-8 [&:not(:last-child)]:mb-8 [&:not(:last-child)]:border-b border-gray-200">
      <div className="flex gap-4">
        <div className="flex-shrink-0">
          <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
            <i className="fa-solid fa-calendar-days text-xl" />
          </div>
        </div>
        <div>
          <h3 className="text-lg font-semibold text-white-900">{event.name}</h3>
          <div className="mt-1">
            <p className="text-sm text-white-600">
              {formatDate(event.date * 1000)} ·{event.location}
            </p>
          </div>
          {event.description && (
            <p className="mt-2 text-white-700">{event.description}</p>
          )}
        </div>
      </div>
    </div>
  )
}
